import { calculateAnchorOfBounds, merge } from "@visactor/vutils";

import { LabelBase } from "./base";

export class RectLabel extends LabelBase {
    constructor(attributes, options) {
        super((null == options ? void 0 : options.skipDefault) ? attributes : merge({}, RectLabel.defaultAttributes, attributes));
    }
    labeling(textBounds, graphicBounds, position = "top", offset = 0) {
        if (!textBounds || !graphicBounds) return;
        const {x1: x1, y1: y1, x2: x2, y2: y2} = textBounds, width = Math.abs(x2 - x1), height = Math.abs(y2 - y1), {x: anchorX, y: anchorY} = calculateAnchorOfBounds(graphicBounds, position);
        let vx = 0, vy = 0;
        const isInside = position.includes("inside");
        switch (position.includes("top") ? vy = isInside ? 1 : -1 : position.includes("bottom") ? vy = isInside ? -1 : 1 : position.includes("left") ? vx = isInside ? 1 : -1 : position.includes("right") && (vx = isInside ? -1 : 1), 
        position) {
          case "top-right":
          case "bottom-right":
            vx = -1;
            break;

          case "top-left":
          case "bottom-left":
            vx = 1;
        }
        return {
            x: anchorX + vx * offset + vx * width / 2,
            y: anchorY + vy * offset + vy * height / 2
        };
    }
}

RectLabel.tag = "rect-label", RectLabel.defaultAttributes = {
    textStyle: {
        fill: "#000"
    },
    position: "top",
    offset: 5
};
//# sourceMappingURL=rect.js.map
